module.exports = __webpack_public_path__ + "static/media/ofertas-shell-select-footer-banner-mobile.1364dfd5.png";